import { Spinner, SpinnerProps } from "@interstate/components/Spinner";
import styled from "styled-components";

const CenteredSpinnerContainer = styled.div<{ $fullHeight?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 60px;

  ${({ $fullHeight }) =>
    $fullHeight &&
    `
    height: 100%;
    min-height: 100vh;
  `}
`;

export interface CenteredSpinnerProps extends SpinnerProps {
  /** Optional container height override */
  containerHeight?: string;
  /** Optional container styles */
  containerStyle?: React.CSSProperties;
  /** When true, container takes full viewport height for page-level loading states */
  fullHeight?: boolean;
}

/**
 * A centered Spinner component that wraps the Interstate Spinner
 * with proper flexbox centering to address Interstate 1.1.0 changes.
 */
export function CenteredSpinner({
  containerHeight,
  containerStyle,
  fullHeight = false,
  ...spinnerProps
}: CenteredSpinnerProps) {
  return (
    <CenteredSpinnerContainer
      $fullHeight={fullHeight}
      style={{
        ...(containerHeight && { minHeight: containerHeight }),
        ...containerStyle
      }}
    >
      <Spinner {...spinnerProps} />
    </CenteredSpinnerContainer>
  );
}

export default CenteredSpinner;
